import { SlideQuestionErrorKeys } from './keys'
import { type ValidationError, type Validator } from './types'

export const validateTitle: Validator = async (context, question) => {
  const errors: ValidationError[] = []
  if (!question.question?.trim()) {
    errors.push({
      field: 'question',
      key: SlideQuestionErrorKeys.question_title_missing,
    })
  }

  return errors
}
